import React from 'react'
import PropTypes from 'prop-types'
import Tab from './tab'
import TabsHeader from './tabs-header'

const Tabs = ({
  activeTab,
  tabHeadings,
  onTabHeadingClick,
  className,
  children,
  numberOfTabs,
}) => {
  const allIndex = Math.min(numberOfTabs - 1, children.length)
  const headings = [...tabHeadings].splice(0, numberOfTabs - 1).concat('All')

  const selectedTab = Math.min(allIndex, activeTab)

  return (
    <div className={className}>
      <TabsHeader
        headings={headings}
        selectedTab={selectedTab}
        onTabHeadingClick={onTabHeadingClick}
      />
      {selectedTab === allIndex ? (
        <Tab isActive role="tabpanel" id={`tabpanel${allIndex}`}>
          {children}
        </Tab>
      ) : (
        children.splice(0, numberOfTabs).map((tab, i) => (
          <Tab
            key={`tab${i}`}
            isActive={selectedTab === i}
            aria-hidden={selectedTab !== i}
            role="tabpanel"
            id={`tabpanel${i}`}
          >
            {tab}
          </Tab>
        ))
      )}
    </div>
  )
}

Tabs.propTypes = {
  activeTab: PropTypes.number,
  tabHeadings: PropTypes.arrayOf(PropTypes.string),
  onTabHeadingClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  numberOfTabs: PropTypes.number,
}

Tabs.defaultProps = {
  activeTab: 0,
  numberOfTabs: 3,
}

export default Tabs
